import { copy } from "shared/assets";
import { DateChangeProps, IFieldType, IFormFields } from "shared/types";

const { userLoyaltyProgram, errors } = copy;

export const getFormFields = ({
  handleIssueDateChange,
  handleExpiryDateChange,
  isIssueBeforeExpiry,
  isExpiryInFuture,
}: {
  handleIssueDateChange: (date: DateChangeProps) => void;
  handleExpiryDateChange: (date: DateChangeProps) => void;
  isIssueBeforeExpiry: boolean;
  isExpiryInFuture: boolean;
}): IFormFields => {
  return [
    {
      name: "programName",
      label: userLoyaltyProgram.fields.programName.title,
      note: userLoyaltyProgram.fields.programName.note,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "programFamily",
      label: userLoyaltyProgram.fields.programFamily.title,
      note: userLoyaltyProgram.fields.programFamily.note,
      type: IFieldType.text,
    },
    {
      name: "issuingCompany",
      label: userLoyaltyProgram.fields.issuingCompany.title,
      note: userLoyaltyProgram.fields.issuingCompany.note,
      type: IFieldType.text,
      style: { gridColumn: "span 2" },
    },
    {
      name: "issueDate",
      label: userLoyaltyProgram.fields.issueDate,
      type: IFieldType.datePicker,
      validation: {
        validate: () => isIssueBeforeExpiry || userLoyaltyProgram.messages.issueBeforeExpiry,
      },
      onChange: (value: string) => handleIssueDateChange({ date: value }),
    },
    {
      name: "expiryDate",
      label: userLoyaltyProgram.fields.expiryDate,
      type: IFieldType.datePicker,
      validation: {
        validate: () => isExpiryInFuture || userLoyaltyProgram.messages.expiryInFuture,
      },
      onChange: (value: string) => handleExpiryDateChange({ date: value }),
    },
    {
      name: "membershipNumber",
      label: userLoyaltyProgram.fields.membershipNumber,
      type: IFieldType.text,
    },
    {
      name: "membershipStatus",
      label: userLoyaltyProgram.fields.membershipStatus,
      type: IFieldType.text,
    },
  ];
};
